import { useCallback, useEffect, useState } from 'react';

import { PortData } from 'features/captains-form/slices/portCallSlice';
import { getPortByUnlocode } from 'features/global/utils/ports';

interface PortsRepositoryParams {
  ports: PortData[];
  unlocode: string;
}

const usePortsRepository = ({ ports, unlocode }: PortsRepositoryParams) => {
  const [port, setPort] = useState<PortData>();

  const getAsyncPort = useCallback(async () => {
    setPort(await getPortByUnlocode({ ports, unlocode }));
  }, [ports, unlocode]);

  useEffect(() => {
    if (unlocode) {
      getAsyncPort();
    }
  }, [getAsyncPort, unlocode]);

  return {
    port,
  };
};

export default usePortsRepository;
